<section class="container mb-2">
  <div>
    <h1 class="page-title">Welcome to TennCare Access</h1>
  </div>
  <div>
    @if (hasPpAccess) {
    <div>
      <p class="mt-2">
        You haven't been approved to use TennCare Access yet. Contact your
        Organization Administrator.
      </p>
      <hr />
    </div>
    } @if (peAccessCdArr.includes('MDB') && displayVADTile) {
    <div
      class="card m-3 p-md-2 d-flex flex-md align-items-center align-items-md-start text-center text-md-start mt-2"
      style="
        background-color: white !important;
        border-color: #132742 !important;
        cursor: unset !important;
      "
    >
      <div class="row" style="width: 102%">
        <div class="col text-start">
          <h5 class="section-header">My Member Assistance Dashboard</h5>
        </div>
        <div class="col text-end">
          <span class="badge">NEW</span>
        </div>
      </div>
      <div
        class="mb-3 mb-md-0 me-0 flex-shrink-0 d-flex justify-content-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="80"
          height="75"
          viewBox="0 0 80 75"
        >
          <defs>
            <filter
              id="BG"
              x="0"
              y="0"
              width="80"
              height="75"
              filterUnits="userSpaceOnUse"
            >
              <feOffset input="SourceAlpha" />
              <feGaussianBlur stdDeviation="4" result="blur" />
              <feFlood flood-color="#d1d3d4" />
              <feComposite operator="in" in2="blur" />
              <feComposite in="SourceGraphic" />
            </filter>
          </defs>
          <g
            id="Group_1528"
            data-name="Group 1528"
            transform="translate(-408 -329)"
          >
            <g transform="matrix(1, 0, 0, 1, 408, 329)" filter="url(#BG)">
              <g
                id="BG-2"
                data-name="BG"
                transform="translate(12 12)"
                fill="#fdefb9"
                stroke="#f4cc43"
                stroke-width="1"
              >
                <rect width="56" height="51" rx="11" stroke="none" />
                <rect
                  x="0.5"
                  y="0.5"
                  width="55"
                  height="50"
                  rx="10.5"
                  fill="none"
                />
              </g>
            </g>
            <path
              id="notifications-outline"
              d="M109.389,73.777c-2.182-2.67-3.722-4.029-3.722-11.391,0-6.741-3.442-9.143-6.276-10.309a1.513,1.513,0,0,1-.845-.9,3.789,3.789,0,0,0-7.48,0,1.5,1.5,0,0,1-.845.895c-2.837,1.168-6.276,3.561-6.276,10.309,0,7.361-1.544,8.72-3.726,11.391a1.713,1.713,0,0,0,1.469,2.767h26.24A1.714,1.714,0,0,0,109.389,73.777Zm-9.148,2.767V77.9l-.569,1.108s-2.606,4.329-4.868,4.329A5.437,5.437,0,0,1,89.367,77.9V76.544"
              transform="translate(353.561 300)"
              fill="none"
              stroke="#132742"
              stroke-linecap="round"
              stroke-width="2.2"
            />
            <circle
              id="Ellipse_2"
              data-name="Ellipse 2"
              cx="3"
              cy="3"
              r="3"
              transform="translate(463 348)"
              fill="#a60000"
            />
          </g>
        </svg>
        <div
          class="flex-grow-1 min-w-0 w-100"
          style="padding-left: 20px !important"
        >
          <div class="section-column" style="margin-top: 1.5rem !important">
            <p>
              You can add members to your Member Assistance Dashboard to see
              their case status and what case actions are needed.
            </p>
          </div>
        </div>
      </div>
      <div class="flex-grow-1 min-w-0 w-100" style="text-align: center">
        <hr style="margin-top: 0 !important" />
        <button class="btn btn-block btn-primary" (click)="viewAccount('VAD')">
          View Member Assistance Dashboard
        </button>
      </div>
    </div>
    }
    <div>
      @if (peAccessCdArr.includes('HPE') || peAccessCdArr.includes('PRG') ||
      peAccessCdArr.includes('BCC')) {
      <div>
        <h2 class="ms-2 section-header">Presumptive Application</h2>
        <hr />
      </div>
      } @if (peAccessCdArr.includes('HPE')) {
      <div
        class="card m-3 p-3 p-md-4 d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start mt-2"
        tabindex="0"
        (click)="startApp('HPE')"
        (keydown.enter)="startApp('HPE')"
        style="cursor: pointer"
      >
        <div
          class="mb-3 mb-md-0 me-0 flex-shrink-0 d-flex justify-content-center"
        >
          <img
            class="col dot"
            alt=""
            aria-hidden="true"
            src="../../../assets/images/Icons/Welcome_Hospital_Pres.svg"
          />
        </div>
        <div class="flex-grow-1 min-w-0 w-100">
          <div class="section-column">
            <strong class="tile_header"
              >Hospital Presumptive Application</strong
            >
            <p>
              Start an application for Hospital Presumptive Eligibility. After
              completing the presumptive eligibility application, you will have
              the option to also submit an application for Medicaid.
            </p>
          </div>
        </div>
      </div>
      } @if (peAccessCdArr.includes('PRG')) {
      <div
        tabindex="0"
        class="card m-3 p-3 p-md-4 d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start mt-2"
        (click)="startApp('PRG')"
        (keydown.enter)="startApp('PRG')"
        style="cursor: pointer"
      >
        <div
          class="mb-3 mb-md-0 me-0 flex-shrink-0 d-flex justify-content-center"
        >
          <img
            class="col dot"
            alt=""
            aria-hidden="true"
            src="../../../assets/images/Icons/Welcome_Presump_Preg.svg"
          />
        </div>
        <div class="flex-grow-1 min-w-0 w-100">
          <div class="section-column">
            <strong class="tile_header"
              >Presumptive Pregnancy Application</strong
            >
            <p>
              Start a Department of Health application for Pregnancy Presumptive
              Eligibility. After completing the pregnancy presumptive
              eligibility application, you will have the option to also submit
              an application for Medicaid.
            </p>
          </div>
        </div>
      </div>
      } @if (peAccessCdArr.includes('BCC')) {
      <div
        tabindex="0"
        class="card m-3 p-3 p-md-4 d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start mt-2"
        (click)="startApp('BCC')"
        (keydown.enter)="startApp('BCC')"
        style="cursor: pointer"
      >
        <div
          class="mb-3 mb-md-0 me-0 flex-shrink-0 d-flex justify-content-center"
        >
          <img
            class="col dot"
            alt=""
            aria-hidden="true"
            src="../../../assets/images/Icons/Welcome_PresumpBCC.svg"
          />
        </div>
        <div class="flex-grow-1 min-w-0 w-100">
          <div class="section-column">
            <strong class="tile_header">Presumptive BCC Application</strong>
            <p>
              Start a Department of Health application for Breast and/or
              Cervical Cancer (BCC) Presumptive Eligibility. After completing
              the BCC presumptive eligibility application, you will have the
              option to also submit an application for Medicaid.
            </p>
          </div>
        </div>
      </div>
      }
    </div>
    @if (peAccessCdArr.includes('TCA') || peAccessCdArr.includes('KPU')) {
    <div>
      <div class="mt-3">
        <h2 class="section-header">Full Coverage Application</h2>
        <hr />
      </div>
      <div
        tabindex="0"
        class="card m-3 p-3 p-md-4 d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start mt-2"
        (click)="startApp('AFB')"
        (keydown.enter)="startApp('AFB')"
        style="cursor: pointer"
      >
        <div
          class="mb-3 mb-md-0 me-0 flex-shrink-0 d-flex justify-content-center"
        >
          <img
            class="col dot"
            alt=""
            aria-hidden="true"
            src="../../../assets/images/Icons/Welcome_FullCovgApp.svg"
          />
        </div>
        <div class="flex-grow-1 min-w-0 w-100">
          <div class="section-column">
            <strong class="tile_header">Apply for Full Coverage</strong>
            <p>
              Start an application for TennCare coverage. This includes TennCare
              and CoverKids. Don’t use this application if you are trying to
              help someone apply for presumptive eligibility (PE) coverage.
            </p>
          </div>
        </div>
      </div>
    </div>
    }
    <h2 class="ms-3 section-header">Other Online Forms and Features</h2>
    <hr />
    <div class="d-flex flex-column w-100">
      @if (peAccessCdArr.includes('NBN')) {
      <div
        tabindex="0"
        class="flex-fill card m-3 p-3 p-md-4 d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start mt-3"
        (click)="viewAccount('NBN')"
        (keydown.enter)="viewAccount('NBN')"
        style="cursor: pointer"
      >
        <div
          class="mb-3 mb-md-0 me-0 flex-shrink-0 d-flex justify-content-center"
        >
          <img
            class="col dot"
            alt=""
            aria-hidden="true"
            src="../../../assets/images/Icons/Welcome_Newborn.svg"
          />
        </div>
        <div class="flex-grow-1 min-w-0 w-100">
          <div class="section-column">
            <strong class="tile_header">Add a Newborn</strong>
            <p>
              You can add a newborn to the mother's case if she is currently
              enrolled in TennCare or CoverKids.
            </p>
          </div>
        </div>
      </div>
      }
    </div>

    @if (peAccessCdArr.includes('ADF')) {
    <div
      tabindex="0"
      class="card m-3 p-3 p-md-4 d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start mt-3"
      (click)="viewAccount('ADF')"
      (keydown.enter)="viewAccount('ADF')"
      style="cursor: pointer"
    >
      <div
        class="mb-3 mb-md-0 me-0 flex-shrink-0 d-flex justify-content-center"
      >
        <img
          class="col dot"
          alt=""
          aria-hidden="true"
          src="../../../assets/images/Icons/Welcome_AdmitDischarge.svg"
        />
      </div>
      <div class="flex-grow-1 min-w-0 w-100">
        <div class="section-column">
          <strong class="tile_header"
            >Admit/Discharge Form for Long-Term Care Facility</strong
          >
          <p>
            Nursing facilities can add the 2350 Form when a patient is admitted
            to or discharged from intermediate long-term care. Only choose this
            option if your patient is enrolled in TennCare or has recently
            applied for TennCare. Form 2350 is not needed if your patient is
            only receiving skilled, short-term care. If your patient has not
            applied for TennCare yet, choose
            <strong>Apply for Full Coverage</strong> to apply on their behalf.
          </p>
        </div>
      </div>
    </div>
    } @if (peAccessCdArr.includes('BXT')) {
    <div
      tabindex="0"
      class="card m-3 p-3 p-md-4 d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start mt-3"
      (click)="viewAccount('BXT')"
      (keydown.enter)="viewAccount('BXT')"
      style="cursor: pointer"
    >
      <div
        class="mb-3 mb-md-0 me-0 flex-shrink-0 d-flex justify-content-center"
      >
        <img
          class="col dot"
          alt=""
          aria-hidden="true"
          src="../../../assets/images/Icons/Welcome_PresumpBCC.svg"
        />
      </div>
      <div class="flex-grow-1 min-w-0 w-100">
        <div class="section-column">
          <strong class="tile_header"
            >Breast and Cervical Cancer Treatment Plan Extension</strong
          >
          <p>
            You can submit a BCC Treatment Plan Extension Form for members who
            need more time to return their treatment plan for BCC coverage.
          </p>
        </div>
      </div>
    </div>
    } @if (peAccessCdArr.includes('LOC')) {
    <div
      tabindex="0"
      class="card m-3 p-3 p-md-4 d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start mt-3"
      (click)="viewAccount('LOC')"
      (keydown.enter)="viewAccount('LOC')"
      style="cursor: pointer"
    >
      <div
        class="mb-3 mb-md-0 me-0 flex-shrink-0 d-flex justify-content-center"
      >
        <img
          class="col dot"
          alt=""
          aria-hidden="true"
          src="../../../assets/images/Icons/Welcome_FinancialReassessment.svg"
        />
      </div>
      <div class="flex-grow-1 min-w-0 w-100">
        <div class="section-column">
          <strong class="tile_header"
            >Financial Reassessment for Medicaid</strong
          >
          <p>
            You can start a financial reassessment for a member who is receiving
            Institutional Medicaid. Review the member’s financial eligibility
            information for the member and other people in their household and
            make updates if needed.
          </p>
        </div>
      </div>
    </div>
    } @if (peAccessCdArr.includes('IME')) {
    <div
      tabindex="0"
      class="card m-3 p-3 p-md-4 d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start mt-2"
      (click)="viewAccount('IME')"
      (keydown.enter)="viewAccount('IME')"
      style="cursor: pointer"
    >
      <div
        class="mb-3 mb-md-0 me-0 flex-shrink-0 d-flex justify-content-center"
      >
        <img
          class="col dot"
          alt=""
          aria-hidden="true"
          src="../../../assets/images/Icons/Welcome_Hospital_Pres.svg"
        />
      </div>
      <div class="flex-grow-1 min-w-0 w-100">
        <div class="section-column">
          <strong class="tile_header">Incurred Medical Expenses (IMEs)</strong>
          <p>
            You can add an Incurred Medical Expense (IME) for individuals who
            are eligible for Institutional Medicaid and receiving Long-Term
            Services and Supports (LTSS) or hospice.
          </p>
        </div>
      </div>
    </div>
    } @if (peAccessCdArr.includes('TCC')) {
    <div
      tabindex="0"
      class="card m-3 p-3 p-md-4 d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start mt-3"
      (click)="viewAccount('TCC')"
      (keydown.enter)="viewAccount('TCC')"
      style="cursor: pointer"
    >
      <div
        class="mb-3 mb-md-0 me-0 flex-shrink-0 d-flex justify-content-center"
      >
        <img
          class="col dot"
          alt=""
          aria-hidden="true"
          src="../../../assets/images/Icons/Welcome_ViewTCC.svg"
        />
      </div>
      <div class="flex-grow-1 min-w-0 w-100">
        <div class="section-column">
          <strong class="tile_header">View TennCare Connect Account </strong>
          <p>
            See a member's TennCare Connect account. This allows you to view
            their coverage and letters, upload documents, report changes, and
            submit renewals on their behalf.
          </p>
        </div>
      </div>
    </div>
    } @if (peAccessCdArr.includes('VTC')) {
    <div
      tabindex="0"
      class="card m-3 p-3 p-md-4 d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start mt-3"
      (click)="viewAccount('VTC')"
      (keydown.enter)="viewAccount('VTC')"
      style="cursor: pointer"
    >
      <div
        class="mb-3 mb-md-0 me-0 flex-shrink-0 d-flex justify-content-center"
      >
        <img
          class="col dot"
          alt=""
          aria-hidden="true"
          src="../../../assets/images/Icons/Welcome_ViewTCC.svg"
        />
      </div>
      <div class="flex-grow-1 min-w-0 w-100">
        <div class="section-column">
          <strong class="tile_header"
            >View TennCare Connect Account (View Only)</strong
          >
          <p>
            See a member's TennCare Connect account. This allows you to view
            their coverage, letters, and documents.
          </p>
        </div>
      </div>
    </div>
    } @if (peAccessCdArr.includes('MPL')) {
    <div
      tabindex="0"
      class="card m-3 p-3 p-md-4 d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start mt-3"
      (click)="viewAccount('MPL')"
      (keydown.enter)="viewAccount('MPL')"
      style="cursor: pointer"
    >
      <div
        class="mb-3 mb-md-0 me-0 flex-shrink-0 d-flex justify-content-center"
      >
        <img
          class="col dot"
          alt=""
          aria-hidden="true"
          src="../../../assets/images/Icons/Welcome_ViewTCC.svg"
        />
      </div>
      <div class="flex-grow-1 min-w-0 w-100">
        <div class="section-column">
          <strong class="tile_header">Member Portal Login</strong>
          <p>
            See past log in details for a member's TennCare Connect Account.
          </p>
        </div>
      </div>
    </div>
    }
    <div
      tabindex="0"
      class="card m-3 p-3 p-md-4 d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start mt-3"
      (click)="searchSubmissions()"
      (keydown.enter)="searchSubmissions()"
      style="cursor: pointer"
    >
      <div
        class="mb-3 mb-md-0 me-0 flex-shrink-0 d-flex justify-content-center"
      >
        <img
          class="col dot"
          alt=""
          aria-hidden="true"
          src="../../../assets/images/Icons/Welcome_SearchSubmissions.svg"
        />
      </div>

      <div class="flex-grow-1 min-w-0 w-100">
        <div class="section-column">
          <strong class="tile_header"> Search My Submissions </strong>
          <p>
            Search for applications you have submitted to review the application
            summary or upload documents if TennCare has not started working the
            application yet. You can also search for applications you have
            started but not finished.
          </p>
        </div>
      </div>
    </div>
    @if (peAccessCdArr.includes('LMC')) {
    <div>
      <h2 class="ms-3 section-header">Other Functions and Features</h2>
      <hr />
      <div class="d-flex flex-column w-100">
        @if (peAccessCdArr.includes('LMC')) {
        <div
          tabindex="0"
          class="flex-fill card m-3 p-3 p-md-4 d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start mt-3"
          (click)="linkCase()"
          (keydown.enter)="linkCase()"
          style="cursor: pointer"
        >
          <div
            class="mb-3 mb-md-0 me-0 flex-shrink-0 d-flex justify-content-center"
          >
            <img
              class="col dot"
              alt=""
              aria-hidden="true"
              src="../../../assets/images/Icons/Welcome_Newborn.svg"
            />
          </div>
          <div class="flex-grow-1 min-w-0 w-100">
            <div class="section-column">
              <strong class="tile_header">Link a Member's Case</strong>
              <p>
                You can link a member's case to their TennCare Connect account
                if you have their Username or Email Address. Link the Head of
                Household to view coverage, letters, upload documents, report
                changes, and submit renewals.
              </p>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
    }
  </div>
</section>